"use client";

export function MapFacilities({ places, zoomToSelectedLoc }) {
  return (
    <div className="grid w-full grid-cols-1 gap-2">
      {places.map((place, index) => (
        <div
          key={index}
          onClick={(e) =>
            zoomToSelectedLoc(e, place.facilities[0], place, index)
          }
          className="flex flex-col justify-between w-full h-24 p-4 transition-all duration-300 border shadow-xl cursor-pointer lg:hover:border-button lg:hover:bg-button lg:hover:text-button-foreground bg-card rounded-card-radius text-card-foreground"
        >
          {place?.facilities?.map((facility, index) => (
            <div key={index} className="flex items-center space-x-2">
              <h4 className="level-4">{facility?.title}</h4>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
